import Environment from '@di-shared/features/environment/Environment';
import Eu from '@di-shared/features/safe-driving-vDSP/SafeDrivingWithdrawBottomSheet/.eu';
import Kr from '@di-shared/features/safe-driving-vDSP/SafeDrivingWithdrawBottomSheet/.kr';

export interface SafeDrivingWithdrawBottomSheetProps {
  vin: string;
}

export default function SafeDrivingWithdrawBottomSheet({vin}: SafeDrivingWithdrawBottomSheetProps) {
  return (
    <>
      <Environment.Kr>
        <Kr vin={vin} />
      </Environment.Kr>
      <Environment.Eu>
        <Eu vin={vin} />
      </Environment.Eu>
    </>
  );
}
